import { cookieStorage } from './cookieStorage';
import { localStorageAdapter } from './localStorageAdapter';
import { ACCESS_TOKEN_KEY, ID_TOKEN_KEY, OKTA_STORAGE_KEY } from './tokenStorage.constants';
import { BrowserStorage } from './storage.types';

export type TokenStorageKey = typeof ACCESS_TOKEN_KEY | typeof ID_TOKEN_KEY;

const tokenStorageByKey: Record<TokenStorageKey, BrowserStorage> = {
  [ACCESS_TOKEN_KEY]: cookieStorage,
  [ID_TOKEN_KEY]: localStorageAdapter,
};

export const getStorageKey = (tokenKey: TokenStorageKey): string => `${OKTA_STORAGE_KEY}_${tokenKey}`;

export const getStorageForTokenKey = (tokenKey: TokenStorageKey): BrowserStorage => tokenStorageByKey[tokenKey];
